<template>
	<li class="staff-expand-header expand-header">
		<div class="grid-container c2" @click="toggle = !toggle">
		  <span class="staff-position text-smaller text-condensed text-uppercase">{{ expander.item_subtitle }}</span>
		  <span class="staff-name text-right text-bold">{{ expander.item_title }}</span>
		</div>
		<prismic-rich-text :field="expander.item_description" class="expander" :class="{ 'is-open': toggle }"/>
	</li>
</template>

<script>

export default {
  name: 'Expander',
  props: ['expander'],
  components: {
  },
  data () {
    return {
	    toggle: false
    }
  },
	methods: {
		getContent () {
	  }
	},
	created () {
	  this.getContent();
  }
}
</script>